import React, {useEffect, useState} from "react";
import {
    convertUniversalDateTimeToPersianDateTime, convertUniversalDateToPersianDate,
    RaikoBaseCardContainer,
    RaikoChipTypes,
    RaikoCustomSimpleChip,
    RaikoCustomTable,
    RaikoFlexFirstChildGrowOne,
    RaikoGridOneColumn,
    RaikoTableTitleContainer,
    showServerErrorMessage
} from "@moeindal/base-raiko-panel-components";
import {MawakibService} from "../../../serverService/mawakibService/MawakibService";
import RaikoDrawer, {RaikoDrawerDirection} from "../../../raikoComponents/raikoDrawer/RaikoDrawer.tsx";
import MawakibServantRegisterDetail from "./MawakibServantRegisterDetail";
import RaikoCardInfoTypeTwo from "../../../raikoComponents/raikoCardInfoTypeTwo/RaikoCardInfoTypeTwo";
import avatar from "../../../assets/images/avatar.svg"
import {css} from "@emotion/css";

export default function MawakibServantRegisters({mawakibId}) {


    let page = 0
    const size = 20

    const service = new MawakibService()

    const [numberOfItems, setNumberOfItems] = useState(0);
    const [servantRegisters, setServantRegisters] = useState([]);
    const [tableLoading, setTableLoading] = useState(false);
    const [totalPage, setTotalPage] = useState(0);
    const [servantRegisterId, setServantRegisterId] = useState(-1)

    useEffect(() => {
        if (mawakibId) {
            getDataFromServer()
        }
    }, []);

    function getDataFromServer() {

        setTableLoading(true)
        service.getMawakibServantRegisters(
            mawakibId,
            page,
            size
        ).then(response => {
            setTotalPage(response.totalPage)
            setNumberOfItems(response.numberOfItems)

            setServantRegisters([])
            response.data.map((item, index) => {
                setServantRegisters(prev => [
                    ...prev,
                    MawakibServantRegistersPrepareNewItem(
                        (page * size) + index + 1,
                        item.id,
                        item.avatar &&  item.avatar.downloadUrl ? item.avatar.downloadUrl.replace("http://","https://") : avatar,
                        item.firstName,
                        item.lastName,
                        item.status,
                        item.sendAt
                    )
                ])
            })

        }).catch(reason => {
            showServerErrorMessage(reason)
        }).finally(_ => {
            setTableLoading(false)
        })
    }

    function handleChangePagination(newPage) {
        page = newPage
        getDataFromServer()
    }

    const [openDrawer, setOpenDrawer] = useState(false)

    function handleOpenDrawer() {
        setOpenDrawer(true)
    }

    function handleCloseDrawer() {
        setOpenDrawer(false)
        setServantRegisterId(-1)
    }

    function handleShowServantRegister(id) {
        setServantRegisterId(id)
        setOpenDrawer(true)
    }

    const [selectDisplayType, setSelectDisplayType] = useState(false)


    return (
        <>
            <RaikoDrawer
                anchor={RaikoDrawerDirection.BOTTOM}
                openDrawer={openDrawer}
                onOpen={handleOpenDrawer}
                onClose={handleCloseDrawer}
            >
                <MawakibServantRegisterDetail id={servantRegisterId} handleCloseDrawer={handleCloseDrawer}/>
            </RaikoDrawer>
            <RaikoGridOneColumn>
                <RaikoBaseCardContainer>
                    <RaikoGridOneColumn>
                        <RaikoFlexFirstChildGrowOne>
                            <RaikoTableTitleContainer
                                title={"خدام ثبت نام شده"}
                                amount={numberOfItems}
                                hasSelectDisplayType
                                selectDisplayType={selectDisplayType}
                                setSelectDisplayType={setSelectDisplayType}
                            />
                        </RaikoFlexFirstChildGrowOne>

                        <RaikoCustomTable
                            header={MawakibServantRegistersHeaders}
                            data={servantRegisters}
                            pageCount={totalPage}
                            isLoading={tableLoading}
                            handlePaginationChange={handleChangePagination}
                            rowClicked={handleShowServantRegister}
                            selectDisplayType={selectDisplayType}

                        >
                            <div className={css`
                                display: grid;
                                grid-template-columns: repeat(5, 1fr);
                                gap: 1rem;
                                @media screen and (max-width: 1024px) {
                                    display: grid;
                                    grid-template-columns: repeat(3, 1fr);
                                    overflow-x: hidden;
                                    gap: .5rem;
                                }
                                @media screen and (max-width: 900px) {
                                    display: grid;
                                    grid-template-columns: repeat(3, 1fr);
                                    overflow-x: hidden;
                                    gap: .5rem;
                                }
                                @media screen and (max-width: 425px) {
                                    display: grid;
                                    grid-template-columns: 1fr 1fr;
                                    overflow-x: hidden;
                                }
                                @media screen and (max-width: 374px) {
                                    display: grid;
                                    grid-template-columns: 1fr;
                                    overflow-x: hidden;
                                }

                            `}>
                                {
                                    servantRegisters.map((item, index) => {
                                        return <RaikoCardInfoTypeTwo
                                            key={index}
                                            title={`${item.firstName} ${item.lastName}`}
                                            subTitle={item.sendAt}
                                            statusState={item.status_text}
                                            onClick={() => {
                                                handleShowServantRegister(item.id)
                                            }}
                                            id={item.id}
                                            photo={item.avatar}
                                        />
                                    })
                                }

                            </div>
                        </RaikoCustomTable>


                    </RaikoGridOneColumn>
                </RaikoBaseCardContainer>
                {/*<ItemList/>*/}

            </RaikoGridOneColumn>
        </>
    )
}
const MawakibServantRegistersHeaders = [
    {
        id: "number",
        label: "#"
    }, {
        id: "photo",
        label: "تصویر خادم"
    }, {
        id: "firstName",
        label: "نام"
    }, {
        id: "lastName",
        label: "نام خانوادگی"
    }, {
        id: "sendAt",
        label: "تاریخ ثبت"
    }, {
        id: "status",
        label: "وضعیت"
    },
]

function MawakibServantRegistersPrepareNewItem(number, id, photo, firstName, lastName, status, sendAt) {
    console.log("avatar" , photo)
    return {
        number,
        id,
        avatar:photo,
        photo: <img
            src={photo}
            className={css`
                border-radius: 8px;
                width: 50px;
                height: 50px;
                aspect-ratio: 1/1;
                object-fit: cover;
            `
            }
            alt=""/>,

        firstName,
        lastName,
        status_text: status,
        status: status === "AWAITING_FOR_REVIEW" ?
            <RaikoCustomSimpleChip title={"در حال بررسی"} type={RaikoChipTypes.warning}/> :
            status === "ACCEPTED" ?
                <RaikoCustomSimpleChip title={"پذیرفته شده"} type={RaikoChipTypes.success}/> :
                <RaikoCustomSimpleChip title={"رد شده"} type={RaikoChipTypes.error}/>,
        sendAt: convertUniversalDateToPersianDate(sendAt),

    }
}
